import * as React from "react"
import { Link } from "react-router-dom"
import { Action, mk_widget, Widget } from "widgets-for-react"
import { LoginState, SignUpState, isSignUpState, LoggedInState } from "../state"
import { Api } from '../api_to_state';
import { notifications } from '../notifications';
import { MinimalLoginWidgetData, update_state_with_route } from "../login";
import { LoginFlowStyle, LoginFlowClasses } from "./style.mod";
import { getClassName } from "../../utils/utils.mod";

function can_sign_up<a, extra_user_info>(s0:SignUpState, api?:Api<extra_user_info>): boolean {
  return !(s0.login_data.name == "" ||
        s0.login_data.name == undefined ||
        s0.login_data.surname == "" ||
        s0.login_data.surname == undefined ||
        s0.login_data.username == "" ||
        s0.login_data.username == undefined ||
        s0.login_data.password == undefined ||
        s0.login_data.email == undefined ||
        !(api && api.scorePassword && api.isValidEmail(s0.login_data.email)) ||
        s0.login_data.email != s0.login_data.confirmed_email ||
        s0.login_data.password != s0.login_data.confirmed_password
  )
}

function handleSubmit<a, extra_user_info>(e:React.FormEvent<HTMLFormElement>, setState:(_: Action<LoginState<a, extra_user_info>>) => void, api:Api<extra_user_info>) {
  e.preventDefault();
  setState(s => isSignUpState(s)
    ? (can_sign_up(s, api) 
      ? ({ ...s, status:"sign up - signing up", login_data:s.login_data }) 
      : { ...s,
          login_data: {
            ...s.login_data,
            username: s.login_data.username == undefined ? "" : s.login_data.username,
            name: s.login_data.name == undefined ? "" : s.login_data.name,
            surname: s.login_data.surname == undefined ? "" : s.login_data.surname,
            email: s.login_data.email == undefined ? "" : s.login_data.email,
            password: s.login_data.password == undefined ? "" : s.login_data.password }
        }
      )
    : s);
}

export function sign_up_form<a, extra_user_info>(
  data:  MinimalLoginWidgetData<a, extra_user_info>,
  options?: { style?: LoginFlowStyle; key?: string }
) {
  return (s0:SignUpState, readonly:boolean, rootpath:string, api?:Api<extra_user_info>) : Widget<Action<LoginState<a, extra_user_info>>> => {
    let name_error = (s0.login_data.name == "");
    let surname_error = (s0.login_data.surname == "");
    let username_error = (s0.login_data.username == "");
    let email_error = (s0.login_data.email != undefined) && !(api && api.scorePassword && api.isValidEmail(s0.login_data.email));
    let confirmed_email_error = (s0.login_data.email != undefined) && (s0.login_data.confirmed_email != s0.login_data.email);
    let password_error = (s0.status == "sign up - error weak password");
    let confirmed_password_error = (s0.login_data.password != undefined) && (s0.login_data.confirmed_password != s0.login_data.password);
    return mk_widget({
      run: (setState: (_: Action<LoginState<a, extra_user_info>>) => void) => {
        return (
          <section className={getClassName(options, "block_classname", "container")} key="login-widget-sign-up-form">
            <div className={getClassName(options, "inner_classname", "py-5")}>
              <header className={getClassName(options, "header_classname", "mb-4")}>
                <h1 className={getClassName(options, "title_classname", "mb-4")}>Register</h1>
                <p className={getClassName(options, "intro_classname", "lead")}>Create a safe password by using a combination of uppercase letters, lowercase letters, numbers and special characters like @, %, and !.</p>
              </header>
    
              <form onSubmit={(e) => handleSubmit(e, setState, api)} className={getClassName(options, "form_classname", "")}>
                <div className={getClassName(options, "form_inner_classname", "")}>
                  {s0.status == "sign up - error account already exists"
                    ? <div className={getClassName(options, "form_alert_classname", "alert alert-danger small")} role="alert">
                        <p>An account with this e-mail address already exists, but it has not been activated yet.</p>
                        <button
                          type="button"
                          className={getClassName(options, "clickable_tertiary_classname", "btn btn-link px-0 py-0")}
                          disabled={readonly}
                          onClick={() => setState(s => s0.status != s.status ? s : { ...s, status: "resend activation - resending", login_data: { email: s0.login_data.email } })}
                        >
                          Send new activation e-mail
                        </button>
                      </div>
                    : notifications(s0, { style: LoginFlowClasses }).run(() => s => s)
                  }
  
                  <div className={getClassName(options, "form_group_classname", "form-group")}>
                    <label
                      htmlFor="name"
                      className={getClassName(options, "form_label_classname", "")}
                    >
                      Name
                    </label>
                    <input
                      type="text"
                      name="name"
                      id="name"
                      aria-invalid={name_error}
                      aria-describedby={name_error ? "a11y-name-error" : null}
                      className={getClassName(options, "form_input_classname", `form-control ${name_error ? "is-invalid" : ""}`)}
                      value={s0.login_data.name || ""}
                      disabled={readonly}
                      onChange={(event) => setState(s => isSignUpState(s) ? ({
                        ...s,
                        status:"sign up",
                        login_data: {
                          ...s.login_data,
                          name: event.currentTarget.value }
                        }) : s)
                      }
                    />
                    {name_error && (
                      <p id="a11y-name-error" className={getClassName(options, "form_error_classname", "invalid-feedback")}>
                        Missing name
                      </p>
                    )}
                  </div>
  
                  <div className={getClassName(options, "form_group_classname", "form-group")}>
                    <label
                      htmlFor="surname"
                      className={getClassName(options, "form_label_classname", "")}
                    >
                      Surname
                    </label>
                    <input
                      type="text"
                      name="surname"
                      id="surname"
                      aria-invalid={surname_error}
                      aria-describedby={surname_error ? "a11y-surname-error" : null}
                      className={getClassName(options, "form_input_classname", `form-control ${surname_error ? "is-invalid" : ""}`)}
                      value={s0.login_data.surname || ""}
                      disabled={readonly}
                      onChange={(event) => setState(s => isSignUpState(s) ? ({
                        ...s,
                        status:"sign up",
                        login_data: {
                          ...s.login_data,
                          surname: event.currentTarget.value }
                        }) : s)
                      }
                    />
                    {surname_error && (
                      <p id="a11y-surname-error" className={getClassName(options, "form_error_classname", "invalid-feedback")}>
                        Missing surname
                      </p>
                    )}
                  </div>
  
                  <div className={getClassName(options, "form_group_classname", "form-group")}>
                    <label
                      htmlFor="username"
                      className={getClassName(options, "form_label_classname", "")}
                    >
                      Username
                    </label>
                    <input
                      type="text"
                      name="username"
                      id="username"
                      aria-invalid={username_error}
                      aria-describedby={username_error ? "a11y-username-error" : null}
                      className={getClassName(options, "form_input_classname", `form-control ${username_error ? "is-invalid" : ""}`)}
                      value={s0.login_data.username || ""}
                      disabled={readonly}
                      onChange={(event) => setState(s => isSignUpState(s) ? ({
                        ...s,
                        status:"sign up",
                        login_data: {
                          ...s.login_data,
                          username: event.currentTarget.value }
                        }) : s)
                      }
                    />
                    {username_error && (
                      <p id="a11y-username-error" className={getClassName(options, "form_error_classname", "invalid-feedback")}>
                        Missing username
                      </p>
                    )}
                  </div>
  
                  <div className={getClassName(options, "form_group_classname", "form-group")}>
                    <label
                      htmlFor="email"
                      className={getClassName(options, "form_label_classname", "")}
                    >
                      E-mail address
                    </label>
                    <input
                      type="text"
                      name="email"
                      id="email"
                      aria-invalid={email_error}
                      aria-describedby={email_error ? "a11y-email-error" : null}
                      className={getClassName(options, "form_input_classname", `form-control ${email_error ? "is-invalid" : ""}`)}
                      value={s0.login_data.email || ""}
                      disabled={readonly}
                      onChange={(event) => setState(s => isSignUpState(s) ? ({
                        ...s,
                        status:"sign up",
                        login_data: {
                          ...s.login_data,
                          email: event.currentTarget.value }
                        }) : s)
                      }
                    />
                    {email_error && (
                      <p id="a11y-email-error" className={getClassName(options, "form_error_classname", "invalid-feedback")}>
                        Invalid email
                      </p>
                    )}
                  </div>
  
                  <div className={getClassName(options, "form_group_classname", "form-group")}>
                    <label
                      htmlFor="confirmed_email"
                      className={getClassName(options, "form_label_classname", "")}
                    >
                      Confirm e-mail address
                    </label>
                    <input
                      type="text"
                      name="confirmed_email"
                      id="confirmed_email"
                      aria-invalid={confirmed_email_error}
                      aria-describedby={confirmed_email_error ? "a11y-confirmed-email-error" : null}
                      className={getClassName(options, "form_input_classname", `form-control ${confirmed_email_error ? "is-invalid" : ""}`)}
                      value={s0.login_data.confirmed_email || ""}
                      disabled={readonly}
                      onChange={(event) => setState(s => isSignUpState(s) ? ({
                        ...s,
                        status:"sign up",
                        login_data: {
                          ...s.login_data,
                          confirmed_email: event.currentTarget.value }
                        }) : s)
                      }
                    />
                    {confirmed_email_error && (
                      <p id="a11y-confirmed-email-error" className={getClassName(options, "form_error_classname", "invalid-feedback")}>
                        The two e-mail addresses are not matching
                      </p>
                    )}
                  </div>
  
                  <div className={getClassName(options, "form_group_classname", "form-group")}>
                    <label
                      htmlFor="password"
                      className={getClassName(options, "form_label_classname", "")}
                    >
                      Password
                    </label>
                    <input
                      type="password"
                      name="password"
                      id="password"
                      aria-invalid={password_error}
                      aria-describedby={password_error ? "a11y-password-error" : null}
                      className={getClassName(options, "form_input_classname", `form-control ${password_error ? "is-invalid" : ""}`)}
                      value={s0.login_data.password || ""}
                      disabled={readonly}
                      onChange={(event) => setState(s => isSignUpState(s) ? ({
                        ...s,
                        status:"sign up",
                        login_data: {
                          ...s.login_data,
                          password: event.currentTarget.value }
                        }) : s)
                      }
                    />
                    {password_error && (
                      <p id="a11y-password-error" className={getClassName(options, "form_error_classname", "invalid-feedback")}>
                        The password is not strong enough
                      </p>
                    )}
                  </div>
  
                  <div className={getClassName(options, "form_group_classname", "form-group")}>
                    <label
                      htmlFor="confirmed_password"
                      className={getClassName(options, "form_label_classname", "")}
                    >
                      Confirm password
                    </label>
                    <input
                      type="password"
                      name="confirmed_password"
                      id="confirmed_password"
                      aria-invalid={confirmed_password_error}
                      aria-describedby={confirmed_password_error ? "a11y-confirmed-password-error" : null}
                      className={getClassName(options, "form_input_classname", `form-control ${confirmed_password_error ? "is-invalid" : ""}`)}
                      value={s0.login_data.confirmed_password || ""}
                      disabled={readonly}
                      onChange={(event) => setState(s => isSignUpState(s) ? ({
                        ...s,
                        status:"sign up",
                        login_data: {
                          ...s.login_data,
                          confirmed_password: event.currentTarget.value }
                        }) : s)
                      }
                    />
                    {confirmed_password_error && (
                      <p id="a11y-confirmed-password-error" className={getClassName(options, "form_error_classname", "invalid-feedback")}>
                        The two passwords are not matching
                      </p>
                    )}
                  </div>  
                
                  <div className={getClassName(options, "form_actions_classname", "")}>
                    <button
                      type="submit"
                      className={getClassName(options, "clickable_primary_classname", "btn btn-dark")}
                      disabled={readonly}
                    >
                      Register
                    </button>
                    
                    {data.without_browserRouter
                      ? <button
                          type="button"
                          className={getClassName(options, "clickable_secondary_classname", "btn btn-link")}
                          onClick={() => setState(update_state_with_route({ kind: "home" }, data))}
                        >
                          Sign in
                        </button>
                      : <Link
                          to={rootpath}
                          className={getClassName(options, "clickable_secondary_classname", "btn btn-link")}
                        >
                          Sign in
                        </Link>
                    }
                  </div>
                </div>
              </form>
            </div>
          </section>
        )
      }
    })
  }
}

export function signup_success<a, extra_user_info>(
  data:  MinimalLoginWidgetData<a, extra_user_info>,
  options?: { style?: LoginFlowStyle; key?: string }
) { 
  return (s0:LoggedInState<extra_user_info>) : Widget<Action<LoginState<a, extra_user_info>>> => {
    return mk_widget({
      run: () => {
        return (
          <section className={getClassName(options, "block_classname", "container")} key="login-widget-sign-up-success">
            <div className={getClassName(options, "inner_classname", "py-5")}>
              <header className={getClassName(options, "header_classname", "mb-4")}>
                <h1 className={getClassName(options, "title_classname", "mb-4")}>Register</h1>
                <p className={getClassName(options, "intro_classname", "lead")}>Your account has been created and you are now logged in.</p>
              </header>
  
              <footer className={getClassName(options, "form_actions_classname", "")}>
                <Link
                  to="/"
                  className={getClassName(options, "clickable_primary_classname", "btn btn-dark")}
                >
                  Continue
                </Link>
              </footer>
            </div>
          </section>
        )
      }
    })
  }
}